var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncrease(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Squircle",
    d: "M0 6.9248C0 1.22223 1.22223 0 6.9248 0H9.0752C14.7778 0 16 1.22223 16 6.9248V9.0752C16 14.7778 14.7778 16 9.0752 16H6.9248C1.22223 16 0 14.7778 0 9.0752V6.9248Z",
    fill: "#E3E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 297",
    d: "M8.00004 3.75736V12.2426M8.00004 3.75736L11.8184 7.57574M8.00004 3.75736L4.18166 7.57574",
    stroke: "#262C2E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncrease);
export default __webpack_public_path__ + "static/media/increase.804a382eaa83bdfe4580d9f4b380cefb.svg";
export { ForwardRef as ReactComponent };